<div class="container is-full-width">
	{#if $isNotInstalled}
		<Installer />
	{:elseif $view == 'splash'}
		<Splashscreen/>
	{:elseif $view == 'verify'}
		<Verify/>
	{:elseif !$loggedIn}
		<Login/>
	{:else}
		<div class="columns is-marginless is-full-height">
			<div class="column is-1 is-paddingless">
				<Toolbar/>
			</div>
			<div class="column is-11 is-paddingless">
				{#if $view == 'innings'}
				<Innings/>
				{:elseif $view == 'roster'}
				<Roster/>
				{:elseif $view == 'depthChart'}
				<DepthChart/>
				{:elseif $view == 'bookmarks'}
				<Bookmarks/>
				{:else}
				<Settings/>
				{/if}
			</div>
		</div>
	{/if}
</div>

<svelte:head>
	<title>{$displayName}</title>
</svelte:head>

<script>
	import Toolbar from './components/Toolbar.html';
	import Innings from './components/Innings.html';
	import Roster from './components/Roster.html';
	import DepthChart from './components/DepthChart.html';
	import Bookmarks from './components/Bookmarks.html';
	import Settings from './components/Settings.html';
	import Splashscreen from './components/Splashscreen.html';
	import Installer from './components/Installer.html';
	import Login from './components/Login.html';
	import Verify from './components/Verify.html';

	export default {
		components: {
			Toolbar,
			Innings,
			Roster,
			DepthChart,
			Bookmarks,
			Settings,
			Splashscreen,
			Installer,
			Login,
			Verify
		}
	};
</script>
